import React, { Component } from 'react';
import dateFormat from 'dateformat';

// Faltantes marcados A MANO que el proveedor volvió a publicar con stock.
//
// Va arriba de todo en el Monitor de Stock, y no dentro de "Sin stock en proveedor", porque es
// lo único de todo el sync que EXIGE una decisión de una persona: el sistema detectó una
// contradicción entre lo que alguien cargó y lo que el proveedor publica, y no puede resolverla
// solo sin borrar información (quien marcó puede saber algo que la web no dice).
//
// Las dos acciones son asimétricas a propósito: "Sí, repuso" devuelve el producto al circuito de
// pedidos; "No, sigue faltando" mantiene la marca y silencia la pregunta por un tiempo, pero no
// la da por resuelta para siempre.
class DiscrepancyCard extends Component {

    render() {
        const { items, onResolve, resolving } = this.props;

        if (!items || items.length === 0) {
            return null;
        }

        return (
            <div className="card card-small mb-4" style={{ borderLeft: '4px solid #007bff' }}>
                <div className="card-header" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="material-icons" style={{ color: '#007bff' }}>help_outline</i>
                    <strong>Revisar: el proveedor repuso</strong>
                    <span className="badge badge-primary">{items.length}</span>
                </div>
                <div className="card-body" style={{ padding: '0 1rem 1rem 1rem' }}>
                    <p className="text-muted mb-3" style={{ fontSize: '13px', marginTop: '10px' }}>
                        Estos productos figuran como "sin stock en proveedor" porque alguien los marcó
                        a mano, pero el proveedor volvió a publicarlos con stock.
                    </p>
                    <table className="transaction-history dataTable no-footer dtr-inline" style={{ width: '100%' }}>
                        <thead>
                            <tr role="row">
                                <th style={{ width: '35%' }}>Producto</th>
                                <th style={{ width: '10%' }}>Stock</th>
                                <th style={{ width: '17%' }}>Marcado a mano</th>
                                <th style={{ width: '18%' }}>El proveedor lo publica</th>
                                <th style={{ width: '20%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, idx) => (
                                <tr role="row" className="odd" key={item.oosId} style={{ background: idx % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                                    <td>{item.name || <span className="text-muted">(producto {item.code})</span>}</td>
                                    <td>{item.stock}</td>
                                    <td className="text-muted">{item.markedAt ? dateFormat(item.markedAt, "dd/mm/yyyy") : '-'}</td>
                                    <td className="text-muted">
                                        {item.contradictedAt ? `desde el ${dateFormat(item.contradictedAt, "dd/mm/yyyy")}` : '-'}
                                    </td>
                                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            style={{ marginRight: '6px' }}
                                            disabled={resolving === item.oosId}
                                            onClick={() => onResolve(item.oosId, 'restocked')}
                                        >
                                            Sí, repuso
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary"
                                            title="Mantiene el producto marcado como faltante y deja de preguntar por un tiempo."
                                            disabled={resolving === item.oosId}
                                            onClick={() => onResolve(item.oosId, 'still_missing')}
                                        >
                                            No, sigue faltando
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default DiscrepancyCard;
